const calculatePowerFromTorque = (torque, rpm) => {
    return ((((torque * (2 * 3.14) * rpm) / 60) / 1000) * 1.36).toFixed(2);
}

const calculateTorqueFromPower = (power, rpm) => {
    return ((((power / (2 * 3.14) / rpm) * 60) * 1000) / 1.36).toFixed(2);
}

const calculateKRKTE = (originalValue, originalInjector, increasedInjector) => {
    return (originalValue * originalInjector) / increasedInjector;
}

const calculateProportion = (a, b, c, d) => {
    let value;
    if (a === 'x' || a == null) {
        value = (b * c) / d;
    } else if (b === 'x' || b == null) {
        value = (a * d) / c;
    } else if (c === 'x' || c == null) {
        value = (a * d) / b;
    } else if (d === 'x' || d == null) {
        value = (b * c) / a;
    } else {
        value = "Errore! Parametri non corretti";
    }

    return value;
}

const perfectDieselStekio = (displacement, cylinderNumber, turboPressure, dieselPerfectStekio, specificWeight) => {
    let singularDisplacement = displacement / cylinderNumber;
    let stekio = (singularDisplacement * turboPressure) / dieselPerfectStekio;
    return {
        'singularDisplacement': singularDisplacement,
        'stekio': stekio,
        'maximum_cube_millimeters': stekio * specificWeight
    };
}

const volumetricEfficiency = (airMass, rpm, displacement, airPressure, airTemperature) => {

    let airMassInGallonsPerSeconds = airMass / 3.6;
    let displacementInLiters = displacement * 0.001;
    let airPressureInInchOfMercury = airPressure * 29.53;
    let airTemperatureInFahrenheit = (airTemperature * 9 / 5) + 32;

    let IAT = (459.68 * (5 / 9)) + airTemperatureInFahrenheit;
    let barometricPressure = airPressureInInchOfMercury * 3386.39;
    let density = barometricPressure / (287 * IAT);

    return airMassInGallonsPerSeconds / (rpm * density * displacementInLiters / 120) * 100;
}

const injectorDimensioning = (power, number, dutyCycle, fuelConsumption) => {
    return ((power * fuelConsumption) / (number * dutyCycle * 0.01)) * 10.5;
}

const injectorFlowRateVariation = (originalFlow, originalPressure, modifiedPressure) => {
    let pressureFlow = Math.sqrt(modifiedPressure / originalPressure);
    return pressureFlow * originalFlow;
}

const dutyCycle = (rpm, injectionTime) => {
    return (rpm * injectionTime) / 1200;
}

const MAPSensorsLinearization = (maxPressure, minPressure, maxTension, minTension) => {
    let maxPressureInMilliBar = maxPressure * 1000;
    let minPressureInMilliBar = minPressure * 1000;
    let DSLGRAD = (maxPressureInMilliBar - minPressureInMilliBar) / (maxTension - minTension);
    let DSLOFS = maxPressureInMilliBar - (DSLGRAD * maxTension);
    return {
        'DSLGRAD': DSLGRAD,
        'DSLOFS': DSLOFS
    }
}

const mgStkToBar = (mgStk) => {
    return (mgStk / 50) / 14.5038;
}

const barToMgStk = (bar) => {
    return (bar * 50) * 14.5038;
}


const createTable = (rowNumber, colNumber) => {
    for (let r = 0; r < parseInt(rowNumber, 10); r++) {
        let x = document.getElementById('myTable').insertRow(r);
        for (let c = 0; c < parseInt(colNumber, 10); c++) {
            let y = x.insertCell(c);
            y.innerHTML = "Row-" + r + " Column-" + c;
        }
    }
}

module.exports = {
    calculatePowerFromTorque, //
    calculateTorqueFromPower, //
    calculateKRKTE, //
    calculateProportion, //
    perfectDieselStekio, //
    volumetricEfficiency, //
    injectorDimensioning, //
    injectorFlowRateVariation,
    dutyCycle, //
    MAPSensorsLinearization, //
    mgStkToBar, //
    barToMgStk, //
    createTable
};
